import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { customerEquipment } from "../constants/customer";

export const addCustomerEquipment = async (bodyData) => {
  try {
    const res = await api.add_customer_equipment(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getCustomerEquipmentList = async (
  dispatch,
  customerId,
  locationId,
  pageNum,
  filters,
  searchString,
  warranty,
) => {
  try {
    const res = await api.customer_equipment_list(
      customerId,
      locationId,
      pageNum,
      filters,
      searchString,
      warranty,
    );
    dispatch({ type: customerEquipment, payload: res.data });
  } catch (error) {
    dispatch({
      type: customerEquipment,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};

export const getCustomerEquipmentById = async (customerEquipmentId) => {
  try {
    const res = await api.customer_equipment_by_ID(customerEquipmentId);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const editCustomerEquipment = async (customerEquipmentId, bodyData) => {
  try {
    const res = await api.edit_customer_equipment(
      customerEquipmentId,
      bodyData,
    );
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteCustomerEquipment = async (customerEquipmentId) => {
  try {
    const res = await api.delete_customer_equipment(customerEquipmentId);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const getEquipmentManual = async (jobId) => {
  try {
    const res = await api.equipmentManual(jobId);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// download equipment invoice
export const downloadEquipmentInvoice = async (equipmentID) => {
  try {
    const res = await api.download_equipment_invoice(equipmentID);
    return res;
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }

    return (
      error.response?.data || {
        code: 500,
        status: "FAILED",
        message: "Failed to download invoice. Please try again.",
      }
    );
  }
}